interface IProps {
  text: string;
}

const DimensionTitle = ({ text }: IProps) => (
  <h5 className="text-xl font-bold text-blue-900 saturate-50">{text}</h5>
);

export default DimensionTitle;
